
// key: string 例：'字段不应为空'
// 属性值：string 例：'字段{name}不应为空' 注：{name} 为变量，需要传入
// 应用举例：
//   方式一： $t('字段不应为空', { name: 'name' }
//   方式二： import { translate } from '@/lang/index'
//            translate('字段不应为空', { name: 'name' }）

export default {
  '数络密盾': '数络密盾',
  '密盾测试': '密盾测试',
  '杭州数络信息技术有限公司': '杭州数络信息技术有限公司',
  '版权所有': '版权所有',
  '浙ICP备15035730号-1': '浙ICP备15035730号-1',
  '是': '是',
  '否': '否',
  '网络请求失败': '网络请求失败',
  '重试': '重试',
  '没有找到该页面': '没有找到该页面',
  '加载中...': '加载中...',
  '月': '月',
  '日': '日',
  '分钟': '分钟',
  '已等待{number}秒': '已等待{number}秒',
  '已等待{number}分钟': '已等待{number}分钟',
  '已等待{number}小时': '已等待{number}小时',
  '已等待{number}天': '已等待{number}天',
  '已等待{number}月': '已等待{number}月',
  '已等待{number}年': '已等待{number}年',

  // 底部导航栏
  '消息': '消息',
  '文档': '文档',
  '工作': '工作',
  '我的': '我的',

  // 流程
  '流程': '流程',
  '文件解密申请': '文件解密申请',
  '信任邮件发送': '信任邮件发送',
  '信任邮箱申请': '信任邮箱申请',
  '文件转密级申请': '文件转密级申请',
  '文件转透明申请': '文件转透明申请',
  '文件授权申请': '文件授权申请',
  '文件外发申请': '文件外发申请',
  '网关信任邮件发送': '网关信任邮件发送',
  '邮件外发申请': '邮件外发申请',
  '文件清除水印申请': '文件清除水印申请',
  '文件标密申请': '文件标密申请',
  '新建': '新建',
  '审批中': '审批中',
  '已通过': '已通过',
  '已拒绝': '已拒绝',
  '已审阅': '已审阅',
  '处理中': '处理中',
  '未处理': '未处理',
  '已处理': '已处理',
  '已完成': '已完成',
  '已取消': '已取消',
  '已终止': '已终止',
  '等待': '等待',
  '发起': '发起',
  '审批': '审批',
  '文件处理': '文件处理',
  '下载解密': '下载解密',
  '发送邮件': '发送邮件',
  '文件已处理': '文件已处理',
  '邮件已发送': '邮件已发送',
  '已下载': '已下载',
  '下载文件': '下载文件',

  '任务已终止': '任务已终止',
  '审批任务没有执行人': '审批任务没有执行人',
  '他人审批通过': '他人审批通过',
  '他人审批拒绝': '他人审批拒绝',
  '他人直接审批完成': '他人直接审批完成',
  '他人已处理': '他人已处理',
  '文件处理任务没有执行人': '文件处理任务没有执行人',
  '流程任务发送邮件失败，status 400，response: email account has not been configured': '流程任务发送邮件失败，没有定义邮箱账号',
  '自动发送失败：流程任务发送邮件失败，status 400，response: 535 Login Fail. Please enter your authorization code to login. More information in https://service.mail.qq.com/detail/0/53': '流程任务自动发送邮件失败，邮箱账号定义错误',
  '文件处理已完成': '文件处理已完成',
  '超过处理期限': '超过处理期限',
  '流程管理员取消流程': '流程管理员取消流程',
  '流程申请人取消流程': '流程申请人取消流程',
  '流程已取消': '流程已取消',
  '流程已终止': '流程已终止',
  '流程已完成': '流程已完成',
  '转为加签审批': '转为加签审批',



  // 登录页面
  '登录': '登录',
  '密码': '密码',
  '请输入账号': '请输入账号',
  '请输入密码': '请输入密码',
  '用户名不能为空': '用户名不能为空',
  '修改密码': '修改密码',

  '手机号/邮箱地址': '手机号/邮箱地址',
  '首次登录或忘记密码?': '首次登录或忘记密码?',
  '我已阅读并同意': '我已阅读并同意',
  '《软件许可与服务协议》': '《软件许可与服务协议》',
  '和': '和',
  '《隐私政策》': '《隐私政策》',
  '隐私保护指引': '隐私保护指引',
  '欢迎您使用': '欢迎您使用',
  '我们非常重视保护您的个人信息，请仔细阅读并理解我们的': '我们非常重视保护您的个人信息，请仔细阅读并理解我们的',
  '请重点关注如下：': '请重点关注如下：',
  '1、为向您提供数字化办公、沟通与协同相关基本功能，我们可能会收集、使用必要的信息；': '1、为向您提供数字化办公、沟通与协同相关基本功能，我们可能会收集、使用必要的信息；',
  '2、我们可能会根据您的使用场景并经您同意后向您获取系统权限，如存储权限等；': '2、我们可能会根据您的使用场景并经您同意后向您获取系统权限，如存储权限等；',
  '3、我们会采取业界先进的安全措施保护您的信息安全；': '3、我们会采取业界先进的安全措施保护您的信息安全；',
  '4、未经您同意，我们不会从第三方处获取、共享或向其提供您的信息。': '4、未经您同意，我们不会从第三方处获取、共享或向其提供您的信息。',
  '同意': '同意',
  '不同意': '不同意',
  '您需要同意隐私政策才能继续使用': '您需要同意隐私政策才能继续使用',
  '若您不同意本隐私政策，很遗憾我们将无法为您提供服务。': '若您不同意本隐私政策，很遗憾我们将无法为您提供服务。',
  '退出应用': '退出应用',
  '查看协议': '查看协议',
  '该项不能为空': '该项不能为空',
  '请输入正确的手机号或邮箱地址': '请输入正确的手机号或邮箱地址',

  '手机号': '手机号',
  '验证码': '验证码',
  '记住账号': '记住账号',
  '使用密码登录': '使用密码登录',
  '获取验证码': '获取验证码',
  '手机号码有误，请重填': '手机号码有误，请重填',
  '密码长度要大于等于6': '密码长度要大于等于6',
  '请阅读并同意服务协议': '请阅读并同意服务协议',
  '手机号码有误': '手机号码有误',
  '验证码已发送': '验证码已发送',
  '{number}秒后重新发送': '{number}秒后重新发送',

  // 关于页
  '测试': '测试',
  '网址': '网址',

  // 我的页
  '关于': '关于',
  '版本更新检查': '版本更新检查',
  '退出登录': '退出登录',

  // 权限申请页面
  '开通文件访问权限': '开通文件访问权限',
  '为了保证正常预览文件，请允许{name}对文件的访问权限': '为了保证正常预览文件，请允许{name}对文件的访问权限',
  '暂不': '暂不',
  '去授权': '去授权',
  '拒绝授权': '拒绝授权',
  '拒绝授权后，{name}将无法帮助您浏览、保存本机文档，请重新授权': '拒绝授权后，{name}将无法帮助您浏览、保存本机文档，请重新授权',
  '不，谢谢': '不，谢谢',

  // APP.vue页面
  '检测到更新': '检测到更新',
  '稍后再说': '稍后再说',
  '立即下载': '立即下载',
  '正在下载更新文件': '正在下载更新文件',
  '再点击一次退出!': '再点击一次退出!',
  '已成功为您安装最新版本': '已成功为您安装最新版本',
  '自动更新': '自动更新',

  // 重置密码页
  '重置密码': '重置密码',
  '请输入手机号或邮箱地址：': '请输入手机号或邮箱地址：',
  '下一步?': '下一步?',
  '验证短信已发送至{phoneNumber},请输入验证码：': '验证短信已发送至{ phoneNumber }, 请输入验证码：',
  '没有收到?': '没有收到?',
  '{number}秒后': '{number}秒后',
  '再次发送': '再次发送',
  '下一步': '下一步',
  '请输入新密码和确认密码：': '请输入新密码和确认密码：',
  '确认密码': '确认密码',
  '提交': '提交',
  '验证邮件已发送至{phoneNumber}，请打开邮件验证邮箱账号，完成密码重置。': '验证邮件已发送至{phoneNumber}，请打开邮件验证邮箱账号，完成密码重置。',
  '返回登录': '返回登录',
  '请输入手机号或邮箱地址': '请输入手机号或邮箱地址',
  '请输入验证码': '请输入验证码',
  '请再次输入密码': '请再次输入密码',
  '密码需包含“大写字母、小写字母、数字、特殊符号”中两种以上的组合，且长度在8到32位': '密码需包含“大写字母、小写字母、数字、特殊符号”中两种以上的组合，且长度在8到32位',
  '两次输入密码不一致': '两次输入密码不一致',
  '密码设置成功': '密码设置成功',
  '密码设置失败': '密码设置失败',

  // 设置密码页
  '设置登录密码': '设置登录密码',
  '设置': '设置',
  '密码不一致': '密码不一致',
  '密码过于简单，请重新输入': '密码过于简单，请重新输入',

  // 修改密码页
  '为您的账号': '为您的账号',
  '设置新密码': '设置新密码',
  '旧密码': '旧密码',
  '请输入旧密码': '请输入旧密码',
  '新密码': '新密码',
  '请输入新密码': '请输入新密码',
  '请确认新密码': '请确认新密码',
  '保存新密码': '保存新密码',
  '按旧密码设置': '按旧密码设置',
  '按验证码设置': '按验证码设置',
  '忘记密码': '忘记密码',
  '点击下方按钮以获取验证码': '点击下方按钮以获取验证码',
  '新密码不能与旧密码相同': '新密码不能与旧密码相同',
  '修改成功，需要重新登录！': '修改成功，需要重新登录！',
  '短信验证码已发送，请输入验证码': '短信验证码已发送，请输入验证码',
  '重新发送': '重新发送',

  // 文档页
  '已选择{number}项': '已选择{number}项',
  '最近': '最近',
  '下载': '下载',
  '暂无符合过滤条件的文档': '暂无符合过滤条件的文档',
  '暂无符合过滤条件的下载文档': '暂无符合过滤条件的下载文档',
  '打开文档': '打开文档',
  '清除记录': '清除记录',
  '取消下载': '取消下载',
  '取消': '取消',
  '暂无文档': '暂无文档',
  '暂无下载文档': '暂无下载文档',
  '确认': '确认',
  '全选': '全选',
  '全不选': '全不选',
  '确定清除选中文档记录': '确定清除选中文档记录',
  '已经到底了': '已经到底了',
  '文件不存在，请先重新下载！': '文件不存在，请先重新下载！',
  '打开文件仅支持Android和IOS系统': '打开文件仅支持Android和IOS系统',
  '预览仅支持Android和IOS系统': '预览仅支持Android和IOS系统',
  '确定删除文档：': '确定删除文档：',
  '请使用{name}APP浏览文档': '请使用{name}APP浏览文档',

  // 消息列表页
  '申请标题': '申请标题',
  '申请描述': '申请描述',
  '系统公告': '系统公告',
  '已经到顶了': '已经到顶了',
  '需要您审批': '需要您审批',

  // 会话列表页
  '暂无消息': '暂无消息',

  // 工作页
  '我的任务': '我的任务',
  '我的申请': '我的申请',
  '请输入审批意见': '请输入审批意见',
  '流程-直接完成': '流程-直接完成',
  '直接完成': '直接完成',
  '流程已直接完成': '流程已直接完成',
  '发起人': '发起人',
  '所在部门': '所在部门',
  '文件': '文件',
  '预览': '预览',
  '已同意': '已同意',
  '等待我审批': '等待我审批',
  '拒绝': '拒绝',
  '等待我下载解密': '等待我下载解密',
  '请至pc端下载解密': '请至pc端下载解密',
  '请至pc端处理': '请至pc端处理',
  '下载异常': '下载异常',
  '等待文件处理': '等待文件处理',
  '确认同意': '确认同意',
  '已同意申请': '已同意申请',
  '确认拒绝': '确认拒绝',
  '已拒绝申请': '已拒绝申请',
  '正在载入': '正在载入',
  '常用功能：': '常用功能：',
  '最近要处理的任务：': '最近要处理的任务：',
  '暂无任务': '暂无任务',
  '新建中': '新建中',
  '审批已通过': '审批已通过',
  '审批已拒绝': '审批已拒绝',
  '审批拒绝': '审批拒绝',
  '文件处理中': '文件处理中',
  '提交申请': '提交申请',

  // 组件
  '重置': '重置',
  '确定': '确定',
  '搜索': '搜索',
  '状态': '状态',
  '类型': '类型',
  '的': '的',
  '没有符合过滤条件的申请': '没有符合过滤条件的申请',
  '没有申请': '没有申请',
  '没有符合过滤条件的任务': '没有符合过滤条件的任务',
  '没有任务': '没有任务',
  '请输入': '请输入',
  '搜索组件': '搜索组件',
  '任务详情': '任务详情',
  '已等待': '已等待',
  '任务名称': '任务名称',
  '审阅': '审阅',
  '暂没有信息！': '暂没有信息！',
  '信息加载失败，请确定是否网络异常！': '信息加载失败，请确定是否网络异常！',

  '过滤条件：': '过滤条件：',
  '全部': '全部',
  '隐私政策': '隐私政策',
  '软件许可与服务协议': '软件许可与服务协议',

  'app需大版本更新，请立即更新到最新版本': 'app需大版本更新，请立即更新到最新版本',
  '当前已是最新版本': '当前已是最新版本',
  '新版本正在下载，请稍后点击': '新版本正在下载，请稍后点击',

  '下拉刷新': '下拉刷新',
  '释放更新': '释放更新',
  '加载完成': '加载完成',
  '没有数据可以加载': '没有数据可以加载',
  '下拉加载更多': '下拉加载更多',
  '释放加载更多': '释放加载更多',
  '上拉加载': '上拉加载',
  '已经到底了!': '已经到底了!',
  '上拉更新': '上拉更新',
  '已经最新了!': '已经最新了!',
  '更新完成': '更新完成',

  // 错误
  '网络异常,请检查网络': '网络异常,请检查网络',
  '服务器访问异常': '服务器访问异常',
  '连接服务器超时({number}秒)': 'Connection to the server timed out ({number} seconds).',
  '网页未找到': '网页未找到',
  '无法连接服务器': '无法连接服务器',
  '此手机号暂未注册': '此手机号暂未注册',
  '手机号日频率限制': '手机号日频率限制',
  '手机号1小时频率限制': '手机号1小时频率限制',
  '请等待60s后再获取新验证码': '请等待60s后再获取新验证码',
  '此邮箱地址暂未注册': '此邮箱地址暂未注册',
  '发送验证邮件失败，请稍后再试': '发送验证邮件失败，请稍后再试',
  '账号被锁定, 请使用密码找回功能重置密码': '账号被锁定, 请使用密码找回功能重置密码',
  '无权登录，请联系管理员授权': '无权登录，请联系管理员授权',
  '用户名或密码错误': '用户名或密码错误',
  '没有找到该用户': '没有找到该用户',
  '没有找到该用户,请重新登录': '没有找到该用户,请重新登录',
  '您没有权限登录!': '您没有权限登录!',
  '当前登录无效!': '当前登录无效!',
  '无权访问当前厂家，请重新登录': '无权访问当前厂家，请重新登录',
  '用户密码已修改，请重新登录': '用户密码已修改，请重新登录',
  '您已经成为厂家正式用户，请重新登录': '您已经成为厂家正式用户，请重新登录',
  '当前账号不属于任何租户，租户信息可能正在审核中，请等待!': '当前账号不属于任何租户，租户信息可能正在审核中，请等待!',
  '验证码错误': '验证码错误',
  '登录已过期，需要重新登录': '登录已过期，需要重新登录',
  '请不要非正常切换页面': '请不要非正常切换页面',
  '消息创建失败:服务端无错误信息': '消息创建失败:服务端无错误信息',
  '没有找到可以上传的文件': '没有找到可以上传的文件',
  '未能解析的错误': '未能解析的错误',
  '客户eds-server服务地址未指定': '客户eds-server服务地址未指定',
  '任务状态错误，该任务已被处理': '任务状态错误，该任务已被处理',
  '该流程不存在，可能已被申请人删除': '该流程不存在，可能已被申请人删除',
  '流程状态错误': '流程状态错误',
  '无法连接至企业端接口服务': '无法连接至企业端接口服务',
  '流程不存在': '流程不存在',
  '读取权限异常': '读取权限异常',
  '文档操作权限申请成功': '文档操作权限申请成功',
  '文档操作权限申请失败，影响文档预览功能': '文档操作权限申请失败，影响文档预览功能',
  '文件[{name}] 下载失败，请稍后再试。': '文件[{name}] 下载失败，请稍后再试。',
  '文件[{name}] 打开失败，可能该加密文件不属于当前企业': '文件[{name}] 打开失败，可能该加密文件不属于当前企业',
  '没有权限预览，因为无租户信息': '没有权限预览，因为无租户信息',
  '服务连接失败': '服务连接失败',
  '客户的EDS服务器App-Key未提供': '客户的EDS服务器App-Key未提供',
  '获取App-Key错误': '获取App-Key错误',
  '文件不存在': '文件不存在',
  '检查文件时出错': '检查文件时出错',
  '验证失败，请重新登录': '验证失败，请重新登录',
  '客户用户不存在': '客户用户不存在',
  '记录不存在': '记录不存在',
  '生成用户令牌出错': '生成用户令牌出错',
  '当前版本不支持': '当前版本不支持',
}